import { IApplicationState } from '../../types/redux';
import { ENewQuestionModalStep } from '../../types/newQuestion';

export const getNewQuestionFormStep = (state: IApplicationState): ENewQuestionModalStep => {
  return state.newQuestion.step;
};
